import CardCarousel from './CardCarousel'

export default CardCarousel
